import type { ICompileService, IRootScopeService } from "angular";

type NgProvider = {
  (name: "$rootScope"): IRootScopeService;
  (name: "$compile"): ICompileService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <T = any>(name: string): T;
};

export const getInjector = () => {
  const injector = window.angular?.element(document)?.injector();
  if (!injector) {
    throw new Error("Unable to get AngularJS injector service");
  }
  return injector;
};

export const getInstance: NgProvider = <T>(name: string): T => getInjector().get(name);
